<mat-spinner *ngIf="loading" style="margin:0 auto;"></mat-spinner>

<form [formGroup]="moduleForm" (ngSubmit)="submit()" fxLayoutAlign="start stretch" fxLayout="column" fxLayoutGap="1.5rem" *ngIf="!loading" #form="ngForm">

    <h1>{{moduleId ? 'Edit' : 'Add'}} Module</h1>

    <mat-card fxLayout="column">

        <mat-form-field class="big">
            <mat-label>Module Name</mat-label>
            <input formControlName="label" name="label" matInput required placeholder="Module Name">
        </mat-form-field>

    </mat-card>

    <h2 fxLayoutAlign="space-between">
        <span *ngIf="moduleForm.get('type').value != ModuleType.SLIDESHOW">
            Pages
        </span>
        <span *ngIf="moduleForm.get('type').value == ModuleType.SLIDESHOW">
            Slides
        </span>
        <div fxLayout="row" fxLayoutGap="1rem">
            <button mat-stroked-button (click)="addSlides()" type="button" color="primary">
                <mat-icon>
                    add
                </mat-icon> 
                Add Slides
            </button>
        </div>
    </h2>

    <div *ngIf="moduleForm.controls.pages['controls'].length == 0" [ngClass]="{alert: form.submitted && moduleForm.controls.pages.invalid}">
        No {{moduleForm.get('type').value == ModuleType.SLIDESHOW ? "Slides" : "Pages"}}
    </div>

    <div formArrayName="pages" gdColumns="repeat(3, minmax(100px, 1fr))" gdGap="1rem" [sortablejs]="moduleForm.get('pages')" *ngIf="moduleForm.get('pages')['controls'].length != 0">

        <mat-card [formGroupName]="pageIndex" *ngFor="let pageGroup of moduleForm.get('pages')['controls']; let pageIndex = index">

            <mat-card-content fxLayoutGap="1rem" fxLayout="column">

                <div fxLayout="row" fxLayoutGap="1rem">

                    <div fxFlex>
                        <h2 style="margin: 0">
                            {{moduleForm.get('type').value == ModuleType.SLIDESHOW ? 'Slide' : 'Page'}} {{pageIndex + 1}}
                        </h2>
                    </div>

                    <button (click)="removePage(pageIndex)" mat-mini-fab fxFlex="nogrow" color="warn" matTooltip="Remove Page" type="button">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <ng-container *ngIf="pageGroup.get('type').value == PageType.QUESTION">

                    <app-module-form-question [formGroup]="pageGroup" [moduleType]="moduleForm.get('type').value"></app-module-form-question>

                </ng-container>

                <ng-container *ngIf="pageGroup.get('type').value == PageType.SLIDE">

                    <app-module-form-slide [formGroup]="pageGroup.get('slide')"></app-module-form-slide>

                </ng-container>

            </mat-card-content>

        </mat-card>
    </div>

    <ng-container *ngIf="form.submitted && moduleForm.invalid">
        <mat-divider></mat-divider>
        <mat-card style="background-color: #ffdfdf; color: red; font-weight: 500;">
            <div>
                Please fix the following errors:
            </div>
            <ul>
                <li *ngIf="moduleForm.controls.label.errors?.required">
                    Module Name not provided
                </li>
                <li *ngIf="moduleForm.controls.pages['controls'].length == 0">
                    No slides have been added to the module
                </li>
                <ng-container *ngFor="let page of moduleForm.controls.pages['controls']; let i = index;">
                    <li *ngIf="page.controls.slide?.controls.content.errors?.required">
                        Slide {{i + 1}} media not found
                    </li>
                </ng-container>
            </ul>
        </mat-card>
    </ng-container>

    <mat-divider></mat-divider>

    <div fxLayoutAlign="end" fxLayoutGap="0.5rem">
        <button type="button" color="warn" mat-stroked-button (click)="cancel()">Cancel</button>
        <button type="submit" color="primary" mat-flat-button>{{moduleId ? 'Edit' : 'Add'}} Module</button>
    </div>

</form>